import axios from 'axios'
import env, { isLocalRunDev } from '@/utils/env'
import { isClient } from '@/utils/is-client'
import logger from '@/utils/logger'

export const getBogusVersion = async (): Promise<string> => {
  const apiBaseUrl = ((): string => {
    if (isLocalRunDev) {
      return 'http://localhost:8080/gin/api'
    }

    if (isClient()) {
      return env.API_BASE_URL
    }

    return process.env.NEXT_PUBLIC_API_GATEWAY_API_BASE_URL ?? ''
  })()

  try {
    const version = await axios
      .get<{ version: string }>(`${apiBaseUrl}/v4/status/version`)
      .then((response) => response.data.version)

    return version
  } catch (e) {
    logger.error(e, { ssr: true })

    return ''
  }
}
